import React from "react";
import { Code2, Handshake, Building2 } from "lucide-react";
import Reveal from "../common/Reveal";

const VALUES = [
  {
    icon: Code2,
    title: "Tech",
    desc: "데이터와 AI 기술의 본질을 이해하고, 이를 제조 현장에 실질적으로 적용할 수 있는 기술력을 쌓아갑니다.",
  },
  {
    icon: Handshake,
    title: "Service & Business",
    desc: "고객의 문제를 가장 가까이에서 이해하고, 말이 아닌 실행으로 실질적인 가치를 만들어냅니다.",
  },
  {
    icon: Building2,
    title: "Corporate",
    desc: "제조업의 디지털 전환을 통해 산업과 사회에 긍정적인 변화를 더하며 함께 성장합니다.",
  },
];

const CoreValues = () => {
  return (
    <section className="py-16">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
        <Reveal>
          <span className="text-sm font-semibold uppercase tracking-wide text-accent-600">
            Core Values
          </span>
          <h2 className="mt-3 break-keep text-3xl font-bold text-primary-900 sm:text-4xl">
            우리가 일하는 방식
          </h2>
          <p className="mx-auto mt-4 max-w-2xl break-keep text-base leading-relaxed text-gray-600">
            MTST의 모든 결정과 실행은 이 세 가지 기준 위에서 이루어집니다.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3">
          {VALUES.map(({ icon: Icon, title, desc }, index) => (
            <Reveal key={title} delay={index * 100}>
              <div className="h-full rounded-xl border border-gray-100 p-8 transition-shadow hover:shadow-lg">
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary-50">
                  <Icon className="h-7 w-7 text-primary-700" strokeWidth={1.75} />
                </div>
                <h3 className="mt-5 text-xl font-bold text-primary-900">
                  {title}
                </h3>
                <p className="mt-2 break-keep text-sm leading-relaxed text-gray-600">
                  {desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
